const isProd = import.meta.env.VITE_STAGE === 'prod';

export const PORTAL_URL = isProd
  ? 'https://portal.anamnia.serankua.tech'
  : 'https://dev.portal.anamnia.serankua.tech';
